import React, { useEffect, useRef, useState } from 'react'
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import * as Fa from "react-icons/fa";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { downloadExcel } from '../../../Services/GlobalFunction/DownLoadExcel';
import { ExcelTemplateDownload, ExcelUpload } from '../../../Services/GlobalFunction/Excel';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import Loader from '../../../Components/Loader';
import { GetDateFormat } from '../../../Services/GlobalFunction/GetDateFormat';
import { fetchData, postData } from '../../../Services/GlobalService';

const SurchargeDefinition = () => {
    const ControllerName = "SurchargeDefinition";

    const EndPoint = {
        GetSurchargeDetails: "GetSurchargeDetails",
        UpdateSurchargeStatus: "UpdateSurchargeStatus"
    };
    const [searchParam] = useSearchParams();
    const surchrgcode = searchParam.get("surchrgcode");

    const nav = useNavigate();
    const fileUploadRef = useRef<FileUpload>(null);

    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState<any>({});

    const [surchargeDesc, setSurchargeDesc] = useState<any>();
    const [activationsts, setActivationsts] = useState("Active");
    const [startDate, setStartDate] = useState<Date | null>();
    const [endDate, setEndDate] = useState<Date | null>();

    const [errorxlsbtn, setErrorxlsbtn] = useState(false);
    const [errorxlsData, setErrorxlsData] = useState([]);

    const [surchrgDetl, setSurchrgDetl] = useState([]);

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const validateForm = () => {
        const newErrors: any = {};

        const SurchargeDescPattern = /^[a-zA-Z0-9\s()\[\]]+$/; // letters, numbers, spaces, ()[]

        if (!surchargeDesc) {
            newErrors.schemeName = "Surcharge description is required";
        } else if (surchargeDesc?.trim()?.length > 50) {
            newErrors.schemeName = "Surcharge description can't be more than 50";
        } else if (!SurchargeDescPattern.test(surchargeDesc)) {
            newErrors.schemeName =
                "Surcharge description can only contain letters, numbers, spaces, and brackets ()[]";
        }
        if (!startDate) newErrors.startDate = "Start Date is required";
        if (!endDate) newErrors.endDate = "End Date is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const downloadTemplate = async () => {
        const res = await ExcelTemplateDownload("SURCHARGE_DEF");
        downloadExcel(res, `SurChargeTemplate.xlsx`)
    }
    const handleFileUpload = async (event: any) => {
        try {
            if (validateForm()) {
                setLoader(true);
                let res = await ExcelUpload(
                    "SURCHARGE_DEF",
                    JSON.stringify({
                        SURCHARGE_DESC: surchargeDesc,
                        SURCHARGE_LEVEL_NO: "20",
                        IS_ACTIVE: activationsts === "Active" ? "Y" : "N",
                        START_DATE: format(startDate ?? "", "dd/MM/yyyy"),
                        END_DATE: format(endDate ?? "", "dd/MM/yyyy"),
                        COL_NAME: "SURCHARGE_CODE"
                    }),
                    event.files[0],
                    "Excel"
                );
                if (res.Status == "Success") {
                    toast.success(res.Message);
                    fileUploadRef.current?.clear();
                    setErrorxlsbtn(false);
                }
                else if (res.Status == "ErrorFR") {
                    toast.warn(res.Message);
                    fileUploadRef.current?.clear();
                    setErrorxlsbtn(false);
                }
                else if (res.Status == "Error") {
                    toast.warn(res.Message);
                    setErrorxlsbtn(true);
                    setErrorxlsData(res.Data);
                }
                setLoader(false);
                nav("/Master/SurchargeDefinition");
            }
        } catch (ex: any) {
            toast.error(ex?.response?.data?.Message);
            fileUploadRef.current?.clear();
            setErrorxlsbtn(false);
            setLoader(false);
        }
    };
    const excelErrorDownload = () => {
        setLoader(true);
        downloadExcel(errorxlsData, `SurchargeUpload_Error${GetDateFormat()}.xlsx`);
        setLoader(false);
    }
    const parseDate = (dateStr: any) => {
        if (!dateStr) return null;

        const [day, month, year] = dateStr.split("/");
        return new Date(year, month - 1, day); // month is 0-based
    };
    const GetSurchargeDetails = async () => {
        setLoader(true);
        try {
            const res = await fetchData(ControllerName, EndPoint.GetSurchargeDetails, `SurChrg_Code=${surchrgcode}`);
            console.log(res.Data, "GetSurchargeDetails");
            setSurchrgDetl(res.Data);
            setSurchargeDesc(res.Data[0]["Surcharge Description"]);
            setStartDate(parseDate(res.Data[0]["Start Date"]));
            setEndDate(parseDate(res.Data[0]["End Date"]));
            setActivationsts(res.Data[0]["Activation Status"] == "Y" ? "Active" : "Inactive");
        } catch (ex) {
            toast.error("Error occurred while fetching the data");
        } finally {
            setLoader(false);
        }
    }
    const UpdateSurchargeStatus = async () => {
        setLoader(true);
        try {
            const Payload = {
                PVCSURCHARGE_CODE: surchrgcode,
                PVCIS_ACTIVE: activationsts === "Active" ? "Y" : "N"
            }
            const res = await postData(ControllerName, EndPoint.UpdateSurchargeStatus, Payload);
            if (res.Status === "Success") {
                toast.success(res.Message);
                GetSurchargeDetails();
            }
            else {
                toast.warn(res?.Message);
            }
        } catch (ex) {
            toast.error("Error occurred while saving the data");
        } finally {
            setLoader(false);
        }
    }
    useEffect(() => {
        if (surchrgcode !== null) {
            GetSurchargeDetails();
        }
    }, [])
    if (loader) {
        return (<Loader />)
    }
    else {
        return (
            <main>
                <div className="col-12 mb-5">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <nav aria-label="breadcrumb" className="drop-in">
                                <ol className="breadcrumb mx-0">
                                    <li className="breadcrumb-item">Masters</li>
                                    <li className="breadcrumb-item">
                                        <Link to="/Master/SurchargeDefinition">
                                            Surcharge Definition
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        View
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <h3 className="py-2">Surcharge Definition</h3>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className='text-end'>
                                <Link to="/Master/SurchargeDefinition">
                                    <button type="button" className="btn anime-secondary-btn">
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All Records
                                    </button>
                                </Link>
                                {surchrgcode !== null && ((surchrgDetl?.[0]?.["Activation Status"] == "Y" ? "Active" : "Inactive") !== activationsts &&
                                    <button
                                        type="button"
                                        title="Save"
                                        className="btn anime-btn ms-2"
                                        onClick={UpdateSurchargeStatus}
                                    >
                                        Save
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                    <div>
                        <section className="sales-box">
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label">Surcharge Description</label>
                                        <InputText
                                            className={
                                                errors.surchargeDesc
                                                    ? "p-invalid w-100"
                                                    : "w-100"
                                            }
                                            value={surchargeDesc}
                                            onChange={(e) => {
                                                setSurchargeDesc(e.target.value);
                                                setErrors({ ...errors, surchargeDesc: null });
                                            }}
                                            placeholder="Enter Surcharge Description"
                                            disabled={surchrgcode !== null}
                                        />
                                        {errors.surchargeDesc && (
                                            <small className="p-error">{errors.surchargeDesc}</small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label">Start Date</label>
                                        <Calendar
                                            className={
                                                errors.startDate
                                                    ? "p-invalid w-100"
                                                    : "w-100"
                                            }
                                            value={startDate}
                                            onChange={(e) => {
                                                setStartDate(e.value as Date);
                                                setEndDate(null);
                                                setErrors({ ...errors, startDate: null });
                                            }}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            placeholder='dd/mm/yyyy'
                                            minDate={tomorrow}
                                            disabled={surchrgcode !== null}
                                        />
                                        {errors.startDate && (
                                            <small className="p-error">{errors.startDate}</small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label">End Date</label>
                                        <Calendar
                                            className={
                                                errors.endDate
                                                    ? "p-invalid w-100"
                                                    : "w-100"
                                            }
                                            value={endDate}
                                            onChange={(e) => {
                                                setEndDate(e.value as Date);
                                                setErrors({ ...errors, endDate: null });
                                            }}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            placeholder='dd/mm/yyyy'
                                            minDate={startDate ? startDate : tomorrow}
                                            disabled={surchrgcode !== null}
                                        />
                                        {errors.endDate && (
                                            <small className="p-error">{errors.endDate}</small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label d-block mb-2">Activation Status</label>
                                        <div className="d-inline-flex">
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="Activation1"
                                                    name="Activation"
                                                    value="Active"
                                                    onChange={(e) => setActivationsts(e.value)}
                                                    checked={activationsts === "Active"}
                                                />
                                                <label
                                                    htmlFor="Activation1"
                                                    className="form-label ms-2 mb-0"
                                                >
                                                    Active
                                                </label>
                                            </div>
                                            <div className="flex align-items-center ms-3">
                                                <RadioButton
                                                    inputId="Activation2"
                                                    name="Activation"
                                                    value="Inactive"
                                                    onChange={(e) => setActivationsts(e.value)}
                                                    checked={activationsts === "Inactive"}
                                                />
                                                <label
                                                    htmlFor="Activation2"
                                                    className="form-label ms-2 mb-0"
                                                >
                                                    Inactive
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {surchrgcode == null && <section className="sales-box">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-lg-8 col-md-12 col-sm-12 clearfix">
                                    <div className="row d-flex justify-content-end align-items-end mb-2">
                                        {/* <div className="col-lg-4 col-md-12 col-sm-12">
                                            <div className="d-block">
                                                <label className="form-label">Upload Type</label>
                                                <Dropdown
                                                    //   value={selectedMenu}
                                                    //   onChange={(e) => setSelectedMenu(e.value)}
                                                    //   options={menuItems}
                                                    //   optionLabel="MENU"
                                                    placeholder='Select file type'
                                                />
                                            </div>
                                        </div> */}
                                        <div className="col-lg-8 col-md-12 col-sm-12">
                                            <div className="text-end">
                                                {errorxlsbtn && <button type="button" className="btn anime-red-btn me-2" onClick={excelErrorDownload}>
                                                    Download Error File <Fa.FaDownload className="ms-2" />
                                                </button>}
                                                <button type="button" className="btn anime-btn" onClick={downloadTemplate}>
                                                    Download Template <Fa.FaDownload className="ms-2" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="UploadSection clearfix">
                                        <div className="conText">
                                            <Fa.FaInfoCircle className="icon" /> Select an Excel File to upload
                                        </div>
                                        <FileUpload
                                            ref={fileUploadRef}
                                            className='clearfix nTopMargin'
                                            name="demo[]"
                                            accept=".xlsx, .xls"
                                            // maxFileSize={1000000} 
                                            emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
                                            customUpload
                                            uploadHandler={handleFileUpload}
                                            onClear={() => {
                                                setErrorxlsbtn(false);
                                            }}
                                            onRemove={() => {
                                                setErrorxlsbtn(false);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <div className="text-end">
                                        <img src={require("../../../Assets/Images/File_Upload.png")} className="File_Upload_Img drop-right" alt="InnoRise" />
                                    </div>
                                </div>
                            </div>
                        </section>}
                        {surchrgcode !== null &&
                            <section className="sales-box col-8 offset-2">
                                <div className='row d-flex justify-content-center align-items-center'>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <h4>Surcharge No <b>{surchrgDetl?.[0]?.["Surcharge Code"]}</b></h4>
                                        <p className='text-secondary mb-0'>Download full surcharge detail report</p>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <div className='text-end'>
                                            <button type="button" className="btn anime-btn me-2" onClick={() => downloadExcel(surchrgDetl, `Surcharge_Detail${GetDateFormat()}.xlsx`)}>Download Report <Fa.FaDownload className='ms-2' /></button>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                    </div>
                </div>
            </main>
        )
    }
}

export default SurchargeDefinition;